
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 42.985c-11.296 0-20.484-9.19-20.484-20.484 0-11.296 9.188-20.485 20.483-20.485 11.296 0 20.485 9.19 20.485 20.485s-9.19 20.484-20.485 20.484M22.5 0C10.093 0 0 10.094 0 22.5s10.093 22.501 22.5 22.501c12.406 0 22.5-10.095 22.5-22.5C45 10.094 34.906 0 22.5 0m7.215 27.256c.184-1.499.286-3.089.286-4.756a39.08 39.08 0 00-.286-4.756c4.704 1.023 7.63 2.96 7.63 4.756 0 1.796-2.926 3.733-7.63 4.756M22.5 37.346c-1.797 0-3.733-2.927-4.756-7.63 1.499.183 3.087.286 4.756.286 1.667 0 3.256-.103 4.756-.286-1.024 4.703-2.96 7.63-4.756 7.63M7.654 22.5c0-1.796 2.928-3.733 7.63-4.756a39.182 39.182 0 00-.286 4.756c0 1.667.103 3.257.286 4.756-4.702-1.023-7.63-2.96-7.63-4.756m20.33 0c0 1.839-.134 3.553-.36 5.125-1.572.227-3.286.36-5.124.36-1.839 0-3.554-.133-5.125-.36a35.907 35.907 0 01-.361-5.125c0-1.839.134-3.552.36-5.125a36.061 36.061 0 015.126-.36c1.838 0 3.552.134 5.125.36.225 1.573.36 3.286.36 5.125M22.5 7.655c1.796 0 3.732 2.926 4.756 7.63a39.392 39.392 0 00-4.756-.286c-1.669 0-3.257.103-4.756.285 1.023-4.703 2.96-7.63 4.756-7.63m6.889 7.957c-1.128-5.98-3.718-9.973-6.89-9.973-3.172 0-5.76 3.992-6.888 9.973-5.982 1.128-9.973 3.718-9.973 6.889 0 3.171 3.991 5.761 9.973 6.889 1.128 5.982 3.716 9.974 6.889 9.974 3.171 0 5.76-3.992 6.889-9.974 5.98-1.128 9.972-3.717 9.972-6.889 0-3.171-3.992-5.761-9.972-6.889"}})])
          )
        }
      }
    